import { Layout as AntdLayout, Row } from "antd";

import styled from "styled-components";
const { Content: AntdContent } = AntdLayout;

export const Layout: typeof AntdLayout = styled(AntdLayout)`
  height: 100%;
`;

export const Content = styled(AntdContent)`
  height: 100%;
  overflow: auto;
`;

export const RowContainer = styled(Row)`
  height: 100%;
  padding: 0 16px;

  > div.logo-container {
    height: 100%;
    width: 36px;
  }

  @media (min-width: 576px) {
    padding: 0 34px;
    > div.logo-container {
      width: 226px;
    }
  }
`;
